
	 /**
	 * @fn isIE
	 * @brief 	DEtermines if the browser is Internet Explorer
	 * @details returns true if the browser is internet explorer, false otherwise.
	 */
	var _isIE = function () {
		return (
			(navigator.appName == 'Microsoft Internet Explorer') ||
			(
				(navigator.appName == 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) != null)
			)
		);
	}

	/**
	 * @fn _hexToRgb
	 * @brief 	Converts a hex color value to a RGB value.
	 * @param 	hex: String specifying the hex color value.
	 * @return 	string specifying the RGB color values (Comma Separated).
	 */
	var _hexToRgb= function(hex) {
	    var bigint;

	    if(hex.indexOf("#") != -1) {
	       var hexVal = hex.substring(hex.indexOf("#") + 1);
	        bigint = parseInt(hexVal, 16);
	    }
	    else {
	        bigint = parseInt(hex, 16);
	    }
	    var r = (bigint >> 16) & 255;
	    var g = (bigint >> 8) & 255;
	    var b = bigint & 255;

	    return r + "," + g + "," + b;
	}
	
	
	 /**
	 * @fn      sanitizeAndParseJQgridJSONforExcelExport
	 * @brief 	Detect app locale and format JSON string exported from jQGrid
	 */

	function sanitizeAndParseJQgridJSONforExcelExport(json_string){
			if(typeof json_string !== 'string'){
				throw new Error('sanitizeJQgridJSONforExcelExport must be passed a string as its argument. Instead it was passed: ' + typeof json_string);
			}
			
      //Replace a function definition and html Italics from string to make sure the JSON is valid.
      json_string = json_string.replace(/\"loadComplete\":.*?,|<i>|<\/i>/g, "");
			
			// First remove any html markup
			json_string = $('<span>' + json_string + '</span>').text();
		
      //Take out the " " from any numbers that have that.
      json_string = json_string.replace(/(\d) (\d)/g, "$1$2");			
      
			// Is the application in French?
			if(Config.getLanguage() == Config.LANGUAGE.FRENCH){

	      // Put dots back in for the commas. 
	      json_string = json_string.replace(/(\d),(\d)/g, "$1.$2");
	      
			}
			else{
	      //Take out the "," from any numbers that have that.
	      json_string = json_string.replace(/(\d),(\d)/g, "$1$2");
	
	      //Take out the " " from any numbers that have that.
	      json_string = json_string.replace(/(\d) (\d)/g, "$1$2");
			}
			
			var grid_object = JSON.parse(json_string);
			
			
			
			return grid_object;
		}
		
		
/**
 * @fn getSubnationalLabel
 * @brief 	Given subnational labels (map level labels), existing conflicts between and within level rank, 
 * and a level rank, returns either specific level name, or generic level name if conflicts exist.
 * @param 	mapLevelConflicts: Object with conflic status for each level rank {1: {hasConflict: boolean},...}.
 * @param 	mapLevelLabels: Object with specific level names that exist for each level rank based on countries 
 * and surveys selected.
 * @param 	levelRank: number specifying desired level rank.
 * @return 	string specifying subnational label for given rank.
 */
const getSubnationalLabel = (mapLevelConflicts, mapLevelLabels, levelRank) => {
	let label = `Subnational ${levelRank}`;
	if (!mapLevelConflicts[levelRank].hasConflict && mapLevelLabels[levelRank].size === 1){
			label = [...mapLevelLabels[levelRank]][0];
	}
	return label;
}

/**
 * @fn addLvlNaToMapLevelLabels
 * @brief Given subnationalLabels, a level rank and a level name, adds level name to subnationalLabels object
 * @param subnationalLabels Object containing level names by level rank 
 * @param levelRank Level Rank at which to add value
 * @param levelNameValue level name value being added
 * @returns subnationalLabels object updated with new value
 */
	const addLvlNaToMapLevelLabels = (subnationalLabels, levelRank, levelNameValue) => {
	if (subnationalLabels){
		if (subnationalLabels[levelRank]){
			subnationalLabels[levelRank].add(levelNameValue);
		} else {
			subnationalLabels[levelRank] = new Set([levelNameValue]);
		}
	} else {
		subnationalLabels = {[levelRank]: new Set([levelNameValue])};
	}
	return subnationalLabels
}

/**
 * @fn extractSubRegionFromLabelName
 * @brief Extract the actual subregion name, trimmed of whitespace from dashboard label
 * e.g. 'Ecological Regions : Mountain (L1)' => 'Ecological Regions'
 * @param name label value
 * @returns string subregion name
 */
const extractSubRegionFromLabelName = (name) => {
	let subRegionStrippedName = '';
	if (name.length > 0 && name.includes(' : ')) {
		subRegionStrippedName = name.split(':')[0].trim();
	}
	return subRegionStrippedName || name;
}

/**
 * @fn extractLevelRnkFromLabelStr
 * @brief Extracts the level rank, or if not found returns null
 * e.g. 'Ecological Regions : Mountain (L1)' => '1'
 * @param name label value
 * @returns level rank as string or null
 */
const extractLevelRnkFromLabelStr = (name) => {
	//matches (L#) with # being any digit
	const regex = /\(L\d\)/g;
	const levelRnkMatches = name.match(regex);
	//level rank should always be the last part of the string, based on the way it is currently created
	const levelRnk = levelRnkMatches && levelRnkMatches[levelRnkMatches.length - 1].slice(2,3);
	return levelRnk;
}